<ngb-accordion
    #acc="ngbAccordion"
    class="qanda"
    activeIds="{{ openSectionPanel }}"
>
    <!-- add activeIds="ngb-panel-0" to open first-->
    <ngb-panel id="p1">
        <ng-template ngbPanelTitle>
            <div class="row justify-content-between">
                <div class="col text-left">
                    <p class="blue-color adelle-sans-17 font-weight-600 mb-0">
                        Anleitung zur Nutzung
                    </p>
                </div>
                <div class="col-2 text-right qa_arrow">
                    <img src="assets/accordion_down.svg" />
                </div>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-0"
                >Lernen</span
            >
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Um Ihren Lernprozess zu beginnen, klicken Sie auf den Button
                „Lernen“ und wählen Sie aus der Kursübersicht Modul I. Durch
                Anklicken der Unterpunkte können Sie die einzelnen
                Lehrmaterialien aufrufen. Beginnen Sie mit dem Studium des
                ersten Kapitels. Nach Abschluss eines Lerninhalts bestätigen
                Sie, dass Sie diesen durchgearbeitet haben, woraufhin Sie
                automatisch zum nächsten Inhalt oder zurück zur Modulübersicht
                geleitet werden.
            </p>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                Menüleiste (oben rechts)
            </span>
            <ul class="adelle-sans-17 font-weight-300 dark-gray">
                <li>
                    <strong>Inhalt:</strong> Zeigt die Struktur der Lerninhalte
                    an der rechten Seite an.
                </li>
                <li>
                    <strong>Notizen:</strong> Ermöglicht das Hinzufügen von
                    persönlichen Notizen zu den Lerninhalten.
                </li>
                <li>
                    <strong>Anpassen:</strong> Öffnet ein Menü zur individuellen
                    Anpassung der Inhaltsdarstellung.
                </li>
                <li>
                    <strong>Dashboard:</strong> Führt Sie zurück zu Ihrer
                    Hauptverwaltungsseite.
                </li>
            </ul>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                Lernstatus
            </span>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Markieren Sie abgeschlossene Themen mit einem Häkchen. Ihr
                Fortschritt wird grafisch und prozentual dargestellt, um Ihnen
                einen ständigen Überblick über Ihre Lernentwicklung zu geben.
                Nachdem Sie ein Modul zu 100 % abgeschlossen haben, wird der
                zugehörige Multiple-Choice-Test freigeschaltet, dessen Bestehen
                das nächste Modul aktiviert.
            </p>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                Zeiterfassung
            </span>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Die Zeiterfassung dokumentiert Ihre Aktivität und pausiert
                automatisch, wenn 15 Minuten lang keine Interaktion (z.B.
                Klicken, Scrollen) stattfindet. Die Erfassung setzt sich mit
                Ihrer nächsten Interaktion fort.
            </p>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                Lernkontrolle
            </span>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Die Lernkontrolle in Form eines Multiple-Choice-Tests steht
                Ihnen zur Verfügung, sobald Sie ein Modul vollständig
                abgeschlossen haben. Nicht bestandene Tests können beliebig oft
                wiederholt werden.
            </p>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                Prüfungsrelevante Inhalte
            </span>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Alle Inhalte, die für die Prüfung relevant sind, sind mit einem
                Stern (*) gekennzeichnet. Eine Übersicht aller
                prüfungsrelevanten Themen finden Sie im Modul „Repetitorium“.
            </p>
            <span class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                Modul Repetitorium
            </span>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Dieses Modul fasst alle prüfungsrelevanten Themen zusammen und
                dient Ihrer gezielten Vorbereitung auf die Abschlussprüfung. Es
                steht Ihnen zur Verfügung, sobald Sie alle vier Lernmodule
                erfolgreich abgeschlossen haben. Die Bearbeitung des
                Repetitoriums ist optional und dient der optimalen
                Prüfungsvorbereitung.
            </p>
        </ng-template>
    </ngb-panel>
    <ngb-panel id="p2">
        <ng-template ngbPanelTitle>
            <div class="row justify-content-between">
                <div class="col text-left">
                    <p class="blue-color adelle-sans-17 font-weight-600 mb-0">
                        Fortbildungspflicht ab Lehrgangsbeginn
                    </p>
                </div>
                <div class="col-2 text-right qa_arrow">
                    <img src="assets/accordion_down.svg" />
                </div>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Bitte stellen Sie sicher, dass Ihr Zeitprotokoll jedes
                Lehrgangsjahr mindestens 15 Stunden Fortbildung nachweist, um
                den Anforderungen der FAO gerecht zu werden.
            </p>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Gemäß § 4 Abs. 2 der Fachanwaltsordnung (FAO) wird mit dem
                Beginn eines Lehrgangs die Verpflichtung zur Fortbildung
                ausgelöst:
                <i
                    >„Wird der Antrag auf Verleihung der Fachanwaltschaft nicht
                    im Kalenderjahr des Lehrgangsbeginns gestellt, muss ab
                    diesem Jahr eine Fortbildung nach Art und Umfang des § 15
                    FAO nachgewiesen werden. Dabei sind die Lehrgangszeiten
                    anzurechnen.“</i
                >
                Weiterhin schreibt § 15 Abs. 3 FAO vor, dass die Gesamtdauer der
                Fortbildung in jedem Fachgebiet mindestens 15 Stunden betragen
                muss.
            </p>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Außerdem erfüllen Sie damit auch die erforderlichen 15 Stunden
                Fortbildung für das Jahr, in dem Sie Ihre Prüfung ablegen und
                müssen somit für dieses Jahr keine weiteren Fortbildungen mehr
                besuchen.
            </p>
        </ng-template>
    </ngb-panel>

    <ngb-panel id="p3">
        <ng-template ngbPanelTitle>
            <div class="row justify-content-between">
                <div class="col text-left">
                    <p class="blue-color adelle-sans-17 font-weight-600 mb-0">
                        Laufzeit des Lehrgangs
                    </p>
                </div>
                <div class="col-2 text-right qa_arrow">
                    <img src="assets/accordion_down.svg" />
                </div>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Ihr Lehrgang ist für die Dauer von 12 Monaten verfügbar. Eine
                Verlängerung ist jederzeit möglich. Jeder zusätzliche Monat
                kostet 35,- €.
            </p>
            <p class="adelle-sans-17 font-weight-300 dark-gray">
                Bitte stellen Sie sicher, dass Sie auch im Jahr Ihrer Prüfung
                mindestens 15 Lehrgangsstunden absolviert haben. Dadurch
                erfüllen Sie gleichzeitig die erforderlichen 15 Stunden
                Fortbildung für das Jahr, in dem Sie Ihre Prüfung ablegen.
            </p>
        </ng-template>
    </ngb-panel>

    <ngb-panel id="p4">
        <ng-template ngbPanelTitle>
            <div class="row justify-content-between">
                <div class="col text-left">
                    <p class="blue-color adelle-sans-17 font-weight-600 mb-0">
                        Informationen zur Abschlussprüfung
                    </p>
                </div>
                <div class="col-2 text-right qa_arrow">
                    <img src="assets/accordion_down.svg" />
                </div>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="adelle-sans-17 font-weight-300 dark-gray">
                <p class="mb-0">
                    <strong class="font-weight-600"
                        >Prüfungsvorbereitung</strong
                    >
                </p>
                <ul>
                    <li>
                        Wir empfehlen die Bearbeitung des Repetitoriums zur
                        optimalen Vorbereitung auf Ihre Prüfung.
                    </li>
                    <li>
                        Das Repetitorium deckt alle prüfungsrelevanten Inhalte
                        ab. Nur die dort behandelten Themen sind
                        prüfungsrelevant.
                    </li>
                </ul>
                <p class="mb-0">
                    <strong class="font-weight-600"
                        >Zugelassene Hilfsmittel</strong
                    >
                </p>
                <ul>
                    <li>Sie dürfen alle Gesetze und Normen verwenden.</li>
                    <li>
                        Markierungen und Kommentare in den Unterlagen sind
                        erlaubt.
                    </li>
                    <li>
                        Sie können die Normen sowohl in digitaler Form als auch
                        ausgedruckt zur Prüfung mitbringen.
                    </li>
                    <li>
                        Es werden nur diejenigen Normen benötigt, die auch für
                        die Bearbeitung des Repetitoriums erforderlich sind.
                    </li>
                </ul>
                <p class="mb-0">
                    <strong class="font-weight-600">Prüfungsablauf</strong>
                </p>
                <ul>
                    <li>
                        Die Prüfung besteht aus drei Klausuren, jede dauert 5
                        Stunden.
                    </li>
                    <li>
                        Jede Klausur umfasst etwa 30 offene Fragen, die sich auf
                        die Inhalte des Repetitoriums beziehen.
                    </li>
                    <li>
                        Es müssen keine Fälle gelöst oder Gutachten erstellt
                        werden.
                    </li>
                </ul>
                <p class="mb-0">
                    <strong class="font-weight-600"
                        >Anmeldung zur Prüfung</strong
                    >
                </p>
                <div>
                    <p class="mb-0">
                        Sie können sich jederzeit zur Abschlussprüfung anmelden.
                        Eine Teilnahme ist jedoch erst möglich, wenn Sie
                        folgende Bedingungen erfüllt haben:
                    </p>
                    <ul>
                        <li>
                            Alle vier Lernmodule sind vollständig bearbeitet.
                        </li>
                        <li>Alle vier Lernkontrollen sind bestanden.</li>
                        <li>
                            Die protokollierte Lernzeit beträgt mindestens 120
                            Stunden, bei Insolvenzrecht 180 Stunden.
                        </li>
                    </ul>
                </div>
                <p class="mb-0">
                    <strong class="font-weight-600">Prüfungsgebühr</strong>
                </p>
                <ul>
                    <li>
                        Die Prüfungsgebühr entsteht erst mit der Teilnahme an
                        der Prüfung.
                    </li>
                </ul>
                <p class="mb-0">
                    <strong class="font-weight-600"
                        >Teilnahme an der Prüfung nach Ablauf der
                        Vertragslaufzeit</strong
                    >
                </p>
                <ul>
                    <li>
                        Sie können auch nach Ablauf Ihrer Vertragszeit an der
                        Prüfung teilnehmen.
                    </li>
                </ul>
            </div>
        </ng-template>
    </ngb-panel>

    <ngb-panel id="p5">
        <ng-template ngbPanelTitle>
            <div class="row justify-content-between">
                <div class="col text-left">
                    <p class="blue-color adelle-sans-17 font-weight-600 mb-0">
                        Individueller Prüfungstermin bei Ihnen vor Ort
                    </p>
                </div>
                <div class="col-2 text-right qa_arrow">
                    <img src="assets/accordion_down.svg" />
                </div>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="adelle-sans-17 font-weight-300 dark-gray">
                <ul>
                    <li>
                        Teilen Sie uns hierfür den anvisierten dreitägigen
                        Prüfungstermin mit.
                    </li>
                    <li>
                        Benennen Sie Ihre Aufsichtsperson (Berufsträger*in) mit
                        E-Mail-Adresse.
                    </li>
                    <li>Uns genügt ein Vorlauf von 14 Tagen.</li>
                    <li>
                        Die Prüfung ist an drei aufeinanderfolgenden Tagen
                        durchzuführen.
                    </li>
                    <li>
                        Die Aufsichtsperson erhält per E-Mail die
                        Prüfungsunterlagen sowie eine Einweisung.
                    </li>
                    <li>
                        Die Aufsichtsperson schickt dann die Klausuren und eine
                        Bestätigung über die ordnungsgemäße Durchführung der
                        Prüfungsaufsicht an uns zurück.
                    </li>
                </ul>
                <p>
                    Für die individuelle Prüfung fällt zusätzlich zur
                    Prüfungsgebühr von 300,- EUR eine einmalige Aufwandsgebühr
                    von 250,- EUR an.
                </p>
                <p>
                    Bei Fragen kontaktieren Sie uns bitte unter
                    <a href="mailto:kontakt@ak-jura.de"
                        >kontakt&#64;ak-jura.de</a
                    >
                    oder telefonisch unter
                    <a href="tel:073160319939">0731 60319939</a>.
                </p>
            </div>
        </ng-template>
    </ngb-panel>

    <ngb-panel id="p6">
        <ng-template ngbPanelTitle>
            <div class="row justify-content-between">
                <div class="col text-left">
                    <p class="blue-color adelle-sans-17 font-weight-600 mb-0">
                        Support und Kontaktmöglichkeiten
                    </p>
                </div>
                <div class="col-2 text-right qa_arrow">
                    <img src="assets/accordion_down.svg" />
                </div>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="adelle-sans-17 font-weight-300 dark-gray">
                <p class="mb-0">
                    <strong class="font-weight-600">Allgemeine Fragen</strong>
                </p>
                <ul>
                    <li>
                        Für allgemeine Anfragen erreichen Sie uns per E-Mail:
                        <a href="mailto:kontakt@ak-jura.de"
                            >kontakt&#64;ak-jura.de</a
                        >
                    </li>
                </ul>
                <p class="mb-0">
                    <strong class="font-weight-600">Technische Fragen</strong>
                </p>
                <ul>
                    <li>
                        Bei technischen Problemen oder Fragen kontaktieren Sie
                        bitte unseren technischen Support:
                        <a href="mailto:support@ak-jura.de"
                            >support&#64;ak-jura.de</a
                        >
                    </li>
                </ul>
                <p class="mb-0">
                    <strong class="font-weight-600">Fachliche Fragen</strong>
                </p>
                <ul>
                    <li>
                        Unser fachlicher Support steht Ihnen für Fragen zur
                        Verfügung, allerdings bitten wir um Verständnis, dass im
                        Rahmen eines Selbststudium-Lehrgangs keine individuelle
                        Betreuung komplexer juristischer Fragen möglich ist.
                        Strukturelle und inhaltliche Anmerkungen sind willkommen
                        und werden zur weiteren Verbesserung der Lehrinhalte an
                        unseren Partner Wolters Kluwer weitergeleitet. Ihre
                        Rückmeldungen sind ein wichtiger Beitrag zur
                        kontinuierlichen Verbesserung unserer Lehrinhalte.
                    </li>
                </ul>
            </div>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
